(function ( $ ) {
	defOptions = {
		'source': 'img/',
		'ext' : '.jpg',
		'count' : 8,
		'speed': 10,
		'imgArray': [],
		'multi': null
	},

	$.fn.rotate3d = function(options) {
		// Set options
		if (!options.source) options.source = defOptions.source;
		if (!options.ext) options.ext = defOptions.ext;
		if (!options.count) options.count = defOptions.count;
		if (!options.speed) options.speed = defOptions.speed;
		if (!options.multi) options.multi = defOptions.multi;
// 		if (!options.speed) options.imgArray = defOptions.imgArray;

		var clickPosition = null,
			first_image = null,
			currentIndex = 0,
			images = [],
			multiImages = {},
			multiActive = null,
			image = null;

		var createImage = function(variant, i) {
			var src = options.multi.baseSrc.replace('[i]', i + 1).replace('[v]', variant);
			var img = new Image();
			img.src = src;
			return img;
		}

		var loadMulti = function(variant) {
			for (var i = 0; i < options.count; ++i) {
				if (multiImages[variant][i]) {
					continue;
				}	
				multiImages[variant][i] = createImage(variant, i);
			}
			
		}

		var loadParallel = function(i) {
			for (var v = 0; v < options.multi.variants.length; ++v) {
				if (multiImages[options.multi.variants[v]][i]) {
					continue;
				}
				multiImages[options.multi.variants[v]][i] = createImage(options.multi.variants[v], i);
			}
		}

		if (options.multi) {
			if (options.multi.initialVariant) {
				multiActive = options.multi.initialVariant;
			} else {
				multiActive = options.multi.variants[0];
			}

			// Init multi arrays
			for (var v = 0; v < options.multi.variants.length; ++v) {
				multiImages[options.multi.variants[v]] = [];
				for (var i = 0; i < options.count; ++i) {
					multiImages[options.multi.variants[v]].push(null);
				}
			}

			loadMulti(multiActive);
			loadParallel(0);
			first_image = multiImages[multiActive][0].src;

			$('body').on('changeRotateSet', function(event, nextSet) {
				multiActive = nextSet;
				image.attr('src', multiImages[multiActive][currentIndex].src);
				loadMulti(multiActive);
			});
		} else {
			// Load images
			for (var i = 0; i < options.count; ++i) {
				var img = new Image();
				img.src = options.imgArray[i];
				images.push(img);
			}
			first_image = options.imgArray[0];
		}

		// Move

		var moveHandler = function(e) {
			var offset = e.clientX - clickPosition;
			if (Math.abs(offset) > options.speed) {
				clickPosition = e.clientX;
				currentIndex = currentIndex + (1 * (offset / Math.abs(offset)));

				if(currentIndex >= options.count) currentIndex = 0;
				if(currentIndex < 0) currentIndex = options.count - 1;	
				if (options.multi) {
					image.attr('src', multiImages[multiActive][currentIndex].src);
				} else {
					image.attr('src', images[currentIndex].src);
				}
			}
		}
        
		$(this).bind('touchstart',function(e){
			
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
			clickPosition = touch.pageX;
		});
		
		$(this).bind('touchmove',function(e){
					e.preventDefault();
					var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
					var elm = $(this).offset();
					var x = touch.pageX - elm.left;
					var y = touch.pageY - elm.top;
					if(x < $(this).width() && x > 0){
							if(y < $(this).height() && y > 0){
								var offset = touch.pageX - clickPosition;
								if (Math.abs(offset) > options.speed) {
										clickPosition = touch.pageX;
										currentIndex = currentIndex + (1 * (offset / Math.abs(offset)));

										if(currentIndex >= options.count) currentIndex = 0;
										if(currentIndex < 0) currentIndex = options.count;
										if (options.multi) {
											image.attr('src', multiImages[multiActive][currentIndex].src);
										} else {
											image.attr('src', images[currentIndex].src);
										}
								}                       
							}
					}
		});        

		var upHandler = function(e){
			if (options.multi) {
				loadParallel(currentIndex);
			}
			$(document).off('mousemove', moveHandler);
		}

		// Init
		$(this).on('drag', function () {
			return false;
		});

		$(this).on('dragdrop', function () {
			return false;
		});

		$(this).on('dragstart', function () {
			return false;
		});

		$(this)
// 			.append($('<img>').attr({'src': options.source + currentIndex + options.ext}))
			.append($('<img>').attr({'src': first_image}))        
			.find('img')
			.on('mousedown', function(e){
				clickPosition = e.clientX;
				$(document).on('mousemove', moveHandler);
			});

		image = $(this).find('img');

		$(document).on('mouseup', upHandler);
	}
}(jQuery));